import { countryList } from "@/config/countries";
import { AddressResponse } from "../api/AddressResponse";

export class Address {
    name: string;
    address: string;
    zip: string;
    city: string;
    countryCode: string;
    mobilePhone: string;
    email: string;
    company: string;
    phoneCode: string;
    internalReference: string;
    iban?: string;

    constructor(resp: AddressResponse) {
        this.name = resp.name;
        this.address = resp.address;
        this.zip = resp.zip;
        this.city = resp.city;
        this.countryCode = resp.countryCode;
        this.email = resp.email;
        this.company = resp.contact;
        this.phoneCode = getPhoneCode(resp.mobilePhone);
        this.mobilePhone = resp.mobilePhone.replace('+' + this.phoneCode, '');
        this.internalReference = resp.internalReference;
        this.iban = resp.iban;
    }
}

function getPhoneCode(mobilePhone: string): string {
    if (!mobilePhone.startsWith('+')) {
        return "";
    }

    for (const country of countryList) {
        const number = mobilePhone.replace("+", "");
        if (number.startsWith((country as any).phoneCode)) {
            return (country as any).phoneCode;
        }
    }

    return "";
}